module.exports = __webpack_public_path__ + "static/media/vrst-2019.cc772fb2.jpg";